import { render, staticRenderFns } from "./PhoneText.vue?vue&type=template&id=5f600672&"
import script from "./PhoneText.vue?vue&type=script&lang=js&"
export * from "./PhoneText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports